export function compactMap<T, R>(items: T[], mapper: (item: T) => R | undefined): R[] {
	return items.reduce<R[]>((result, item) => {
		const mapped = mapper(item);
		return mapped != null ? result.concat(mapped) : result;
	}, []);
}